import { Component } from '@angular/core';
import {MarkdownComponent, provideMarkdown} from 'ngx-markdown';

@Component({
  selector: 'app-introduction-help',
  imports: [
    MarkdownComponent
  ],
  templateUrl: './introduction-help.component.html',
  styleUrl: './introduction-help.component.scss',
  providers: [
    provideMarkdown(),
  ],
})
export class IntroductionHelpComponent {

}
